export enum ColumnsLabel {
  SELECT_ALL = 'Select all',
  DESELECT_ALL = 'Deselect all',
}

export enum CheckBoxStates {
  NOT_SELECTED = 0,
  SELECTED_ALL = 1,
  INDETERMINATE = 2,
}

export enum TABLE_ROW_TYPES {
  HEAD = 'head',
  BODY = 'body',
}

export enum TableColumnsIds {
  PERIOD = 'period',
  DUE_DATE = 'dueDate',
  ORIGINAL_AMOUNT = 'amount',
  AMOUNT_USD = 'amountUsd',
  PAID_AMOUNT = 'amountPaid',
  ACTIONS = 'actionsFixedRightInvoices',
  EXPANDED_ITEM = 'expandedItem',
  DATE = 'invoiceSummaryDate',
  NAME = 'name',
  NUMBER = 'number',
}
